import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchMessages,
  viewMessage,
  dismissMessages,
  fetchUnreadMessages
} from "../../redux/actions/messagesActions";
import Messages from "../../views/Messages";

class LearningCenterMessages extends Component {
  componentDidMount() {
    this.props.fetchMessages();
  }

  dismissMessages = (messageIds, sorting) => {
    this.props.dismissMessages(messageIds, () => {
      this.props.fetchMessages(sorting);
      this.props.fetchUnreadMessages();
    });
  };

  sort = params => {
    this.props.fetchMessages(params);
  };

  render() {
    const data = this.props.messageData.map(msg => {
      return {
        checked: false,
        subject: msg.message.subject,
        from: msg.message.fromFirstName + " " + msg.message.fromLastName,
        date: msg.message.calendarDate,
        isNew: msg.unread,
        description: msg.message.text,
        id: msg.id
      };
    });
    return (
      <Messages
        data={data}
        onRowExpand={this.props.viewMessage}
        onDelete={this.dismissMessages}
        onSort={this.sort}
      />
    );
  }
}

const mapStateToProps = state => ({
  messageData: state.messagesState.messages,
  error: state.messagesState.error
});

export default connect(mapStateToProps, {
  fetchMessages,
  viewMessage,
  dismissMessages,
  fetchUnreadMessages
})(LearningCenterMessages);
